import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

import { AlluLogo } from "@/components/parceiros/AlluLogo";

const NAV = [
  { href: "#depoimentos", label: "Depoimentos" },
  { href: "#quem-e-a-allu", label: "Quem é a Allu" },
];

export const EventoHeader = () => {
  return (
    <header className="sticky top-0 z-50 w-full backdrop-blur bg-[#0B1A0B]/85 border-b border-white/10">
      <div className="container-wide flex items-center justify-between gap-3 py-4">
        <a href="/evento" aria-label="Allu" className="block shrink-0">
          <AlluLogo variant="light" className="h-8 sm:h-10 md:h-12 w-auto" />
        </a>

        <nav className="hidden md:flex items-center gap-5 lg:gap-7 text-sm font-medium text-zinc-300">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="hover:text-white transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3 sm:gap-4">
          <Link
            to="/evento/aplicar"
            className="inline-flex items-center justify-center gap-1.5 rounded-full font-semibold text-sm h-10 sm:h-11 px-5 sm:px-6 bg-[#4BD084] hover:bg-[#5fdc94] text-[#112711] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-[#0B1A0B] focus-visible:ring-[#4BD084]"
          >
            Quero me candidatar
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </header>
  );
};
